<template>
  <div class="AddressForm ">
    <h3>{{ $t('form.address.block_name') }}</h3>
    <div v-if="loaded">
      <AddressGeocode :address="address" :showErrors="showErrors" v-on:address-geocode="handleAddressGeocode" />
    </div>
  </div>
</template>

<script>
import {
  getAddress,
  updateAddress,
  setLocation
} from "@/api/address.js";
import { mapGetters } from "vuex";
import AddressGeocode from '@/snippets/AddressGeocode.vue';

export default {
  name: 'AddressForm',
  props: {
    autoSave: {
      type: Boolean,
      default: true
    },
    showErrors: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      googleApiKey: this.$parent.googleApiKey,
      address: {},
      loaded: false,
    };
  },
  computed: {
    ...mapGetters({
      axiosBusy: "axiosIsBusy",
    }),
  },
  created() {
    this.fetchData();
  },
  methods: {
    allValid: function() {
      if ( this.address.country &&
        this.address.locality &&
        this.address.street.length >= 3 &&
        this.address.streetnumber &&
        this.address.zip && this.address.zip.length >= 3
      ) {
          return true;
      } else {
          return false;
      }
    },
    async fetchData() {
      const rv = await getAddress(this.$userClient);
      if (rv) {
        this.address = rv.address;
        this.loaded = true;
      }
    },
    async handleAddressGeocode(e) {
      const rv = await updateAddress(this.$userClient, e.address);
      if (rv) {
        this.address = rv.address;
        if (e.status == 'success') {
          await setLocation(this.$frontendClient, { lat: this.address.lat, lng: this.address.long, quality: "USER" });
        }
        this.$emit('user-data-updated', {subform: 'address', 'return': rv});
      } else {
        alert(this.$t('form.address.address_update_error'));
      }
    },
  },
  components: {
    AddressGeocode
  },
}
</script>
